import { VStack } from '@chakra-ui/react';
import React from 'react';
import { ScreenSectionSymbols } from './PosScreen.Sections';
import * as ThemeManager from './ThemeManager';

export function Sidebar({ children }: React.PropsWithChildren): React.ReactNode {

	return ThemeManager.isLargeDevice()
		? <VStack h='full' w='18' flexShrink={'0'} bg={{ base: '{colors.blue.700}', _dark: '{colors.blue.900}' }} paddingY={'6'} gap='9' color={{ base: 'white', _dark: 'white' }}>
			{children}
		</VStack>
		: null;
}

(Sidebar as any)[ScreenSectionSymbols.Sidebar] = true;